import { render, staticRenderFns } from "./TemplatesCode.vue?vue&type=template&id=f46ed6fe&scoped=true"
import script from "./TemplatesCode.vue?vue&type=script&lang=js"
export * from "./TemplatesCode.vue?vue&type=script&lang=js"
import style0 from "./TemplatesCode.vue?vue&type=style&index=0&id=f46ed6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46ed6fe",
  null
  
)

export default component.exports